//@flow
import * as React from 'react';
import { ProviderDataFetcher } from 'common/modules/provider';

import { usePlatformSettings } from 'common/modules/platform-settings';

type Props = {
    children: React.Node
};

const ProviderDataFetcherWrap = ({ children }: Props): React.Node => {
    const settings = usePlatformSettings();
    const { whiteLabelSettings } = settings.platformSettings;
    return (
        <ProviderDataFetcher providerId={whiteLabelSettings?.provider}>
            {children}
        </ProviderDataFetcher>
    );
};

export default ProviderDataFetcherWrap;
